import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface DatePickerProps extends KendoWidgetProps, kendo.ui.DatePickerOptions {
    children?: React.ReactNode;
}

export default class DatePicker extends KendoBaseComponent<DatePickerProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.DatePicker(domNode as Element, (props as kendo.ui.DatePickerOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
            (this.widgetInstance as kendo.ui.DatePicker).value(props.value as Date);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'input'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <input ref={this.elementRef} />;
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-react-wrapper/src/datepicker/index.tsx